// Shape Twinden on the page (M55, docs/run-by-families.md D198–D200).

import { IDEA_LIMITS } from '@twinden/shared';
import type { MessageKey, Vars } from '../i18n';
import type { Idea } from './api';

export interface FieldProblem {
  key: MessageKey;
  vars?: Vars;
}

/** What's wrong with an idea as typed, in the page's own words (D198). */
export function checkIdea(
  title: string,
  body: string
): { title: FieldProblem | null; body: FieldProblem | null; ok: boolean } {
  const trimmedTitle = title.trim();
  const trimmedBody = body.trim();
  const titleProblem: FieldProblem | null = !/\p{L}|\p{N}/u.test(trimmedTitle)
    ? { key: 'site.ideas.sheet.titleNeeded' }
    : trimmedTitle.length > IDEA_LIMITS.TITLE_MAX
      ? {
          key: 'site.ideas.sheet.tooLong',
          vars: { count: trimmedTitle.length - IDEA_LIMITS.TITLE_MAX },
        }
      : null;
  const bodyProblem: FieldProblem | null =
    trimmedBody.length > IDEA_LIMITS.BODY_MAX
      ? {
          key: 'site.ideas.sheet.tooLong',
          vars: { count: trimmedBody.length - IDEA_LIMITS.BODY_MAX },
        }
      : null;
  return {
    title: titleProblem,
    body: bodyProblem,
    ok: !titleProblem && !bodyProblem,
  };
}

/** The poster may edit for 15 minutes after posting (D200). */
export function canEditIdea(idea: Idea, now = Date.now()): boolean {
  return (
    !!idea.mine &&
    now - new Date(idea.createdAt).getTime() <
      IDEA_LIMITS.EDIT_MINUTES * 60 * 1000
  );
}

/** A vote, or taking it back, applied straight away (optimistic). */
export function withVote(idea: Idea, vote: boolean): Idea {
  if (!!idea.votedByMe === vote) return idea;
  return {
    ...idea,
    votedByMe: vote,
    votesCount: Math.max(0, idea.votesCount + (vote ? 1 : -1)),
  };
}

/**
 * The board's sections, keeping the list's order (the server's, D199) so
 * nothing jumps under your finger when you vote.
 */
export function ideaSections(ideas: readonly Idea[]) {
  return {
    active: ideas.filter(
      (idea) => idea.status !== 'done' && idea.status !== 'not_now'
    ),
    done: ideas.filter((idea) => idea.status === 'done'),
    notNow: ideas.filter((idea) => idea.status === 'not_now'),
  };
}
